import React from 'react';
import PropTypes from 'prop-types';
import classes from './style.module.scss';

function StatusField({ status }) {
  let statusClass = '';

  if (status.includes('Prior Auth')) {
    statusClass = 'Prior';
  } else if (status.includes('Copay')) {
    statusClass = 'Copay';
  }

  return (
    <div className={`${classes.statusStyle} ${classes[statusClass || status]}`}>
      <p>{status}</p>
    </div>
  );
}

StatusField.propTypes = {
  status: PropTypes.string.isRequired,
};

export default StatusField;
